import { useState } from 'react'
import React from 'react'
import Container from './container'

export default function Verticais() {
  const [hoveredBrand, setHoveredBrand] = useState(null)
  const brands = [
    {
      id: 'solutions',
      name: 'SOLUTIONS',
      brand1: 'omni',
      brand2: 'core',
      color: '#4B3BDB',
      bgGlow: 'rgba(0, 0, 255, 0.5)',
      services: [
        { name: 'ERP', url: '/erp' },
        { name: 'Consulting', url: '/omnifactory' },
      ],
    },
    {
      id: 'projects',
      name: 'PROJECTS',
      brand1: 'be.',
      brand2: 'hub',
      color: '#A002CB',
      bgGlow: 'rgba(188, 63, 229, 0.5)',
      services: [
        { name: 'Development', url: '/development' },
        { name: 'Business Agility', url: '/business-agility' },
      ],
    },
    {
      id: 'innovation',
      name: 'INNOVATION',
      brand1: 'next',
      brand2: '2AI',
      color: '#FC0021',
      bgGlow: 'rgba(255, 0, 0, 0.5)',
      services: [
        { name: 'IA', url: '/ia' },
        { name: 'Cloud', url: '/cloud' },
      ],
    },
  ]

  return (
    <div className="w-full bg-[#040116] pt-16 pb-24 md:pb-32 relative overflow-hidden">
      <Container>
        <div className="text-center text-white mb-24 text-2xl md:text-3xl lg:text-4xl max-w-[719px] mx-auto">
          <h1 className="font-inter-regular text-white text-center my-4 break-words">
            <strong className="font-inter-bold">
              Geramos transformação de alto impacto
            </strong>{' '}
            a partir de 3 empresas especialistas.
          </h1>
        </div>
        {/* Brands section */}
        <div className="relative">
          <div className="absolute inset-0 w-full h-full flex flex-col">
            {brands.map(brand => (
              <div
                key={brand.id}
                className="absolute inset-0 transition-all duration-700 ease-in-out h-full"
                style={{
                  background:
                    hoveredBrand === null
                      ? `linear-gradient(${window.innerWidth < 1023 ? '0deg' : '90deg'},
                                         ${brands[0].bgGlow} 0%,
                                         ${brands[1].bgGlow} 50%,
                                         ${brands[2].bgGlow} 100%)`
                      : hoveredBrand === brand.id
                        ? `radial-gradient(circle at ${
                            brand.id === 'solutions'
                              ? '25%'
                              : brand.id === 'projects'
                                ? '50%'
                                : '75%'
                          } 50%, ${brand.bgGlow} 0%, rgba(4, 1, 22, 0.9) 70%)`
                        : 'transparent',
                  opacity:
                    hoveredBrand === null
                      ? 1
                      : hoveredBrand === brand.id
                        ? 1
                        : 0,
                  filter: 'blur(60px)',
                  zIndex: 0,
                }}
              />
            ))}
          </div>
          {/* Brand content */}
          <div className="flex flex-col md:flex-row justify-between items-center h-full relative z-10 mx-8 md:mx-12 gap-4 lg:gap-8">
            {brands.map(brand => (
              <div
                key={brand.id}
                className="w-full md:flex-1 text-center px-10 md:px-4 transition-all duration-500 relative"
                onMouseEnter={() => setHoveredBrand(brand.id)}
                onMouseLeave={() => setHoveredBrand(null)}
              >
                {/* Card border that appears on hover */}
                <div
                  className={`absolute inset-0 z-0 transition-opacity duration-50 mt-10 ${
                    hoveredBrand === brand.id ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  {/* Borda lateral e inferior */}
                  <div
                    className="absolute left-0 right-0 bottom-0 top-0 border-l-2 border-r-2 border-b-2 border-white border-opacity-20 rounded-b-lg transition-all duration-500"
                    style={{
                      borderTop: 'none',
                      transform:
                        hoveredBrand === brand.id
                          ? 'translateY(0)'
                          : 'translateY(10px)',
                    }}
                  />
                  {/* Círculo e linha superior esquerda */}
                  <div
                    className="absolute -top-4 -left-4 flex flex-col items-center transition-all duration-500"
                    style={{
                      transform:
                        hoveredBrand === brand.id
                          ? 'translateY(0)'
                          : 'translateY(10px)',
                    }}
                  >
                    <div className="size-9 rounded-full border-2 border-dashed border-white border-opacity-20 flex items-center justify-center">
                      <div className="w-3 h-3 bg-white rounded-full" />
                    </div>
                  </div>
                  {/* Círculo e linha superior direita */}
                  <div
                    className="absolute -top-1 right-0 flex flex-col items-center transition-all duration-500"
                    style={{
                      transform:
                        hoveredBrand === brand.id
                          ? 'translateY(0)'
                          : 'translateY(10px)',
                    }}
                  >
                    <div className="w-10 h-10 border-t-2 border-l-2 border-white rounded-tl-md rotate-90" />
                  </div>
                </div>
                <div
                  className={`relative z-10 transition-all duration-500 py-6 mx-0 md:mx-6 ${
                    hoveredBrand && hoveredBrand !== brand.id
                      ? 'opacity-40 scale-90'
                      : 'opacity-100 scale-100'
                  } ${hoveredBrand === brand.id ? 'text-left' : 'text-center'}`}
                >
                  {/* Brand header */}
                  <div
                    className={`flex items-center mb-2 ${
                      hoveredBrand === brand.id
                        ? 'justify-start'
                        : 'justify-center'
                    }`}
                  >
                    {hoveredBrand !== brand.id && (
                      <div className="p-1 rounded-full mr-4 border-1 border-dashed border-white border-opacity-70 flex items-center justify-center">
                        <div className="size-2 bg-white rounded-full " />
                      </div>
                    )}
                    <h3 className="text-2xl md:text-3xl font-inter-bold text-white">
                      {brand.name}
                    </h3>
                  </div>
                  {/* Brand logo */}
                  <div
                    className={`flex ${
                      hoveredBrand === brand.id
                        ? 'justify-start'
                        : 'justify-center'
                    }`}
                  >
                    <img
                      src={
                        brand.id === 'solutions'
                          ? '/assets/omnicore_logo.svg'
                          : brand.id === 'projects'
                            ? '/assets/behub_logo.svg'
                            : '/assets/next2ai_logo.svg'
                      }
                      alt={`${brand.brand1}${brand.brand2} logo`}
                      className={`h-8 transition-all duration-500 ${
                        hoveredBrand === brand.id
                          ? brand.id === 'projects'
                            ? '-ml-6'
                            : 'ml-4'
                          : ''
                      }`}
                      style={{
                        opacity:
                          hoveredBrand === null || hoveredBrand === brand.id
                            ? 1
                            : 0.4,
                        transform:
                          brand.id === 'projects'
                            ? 'scale(0.68)'
                            : 'scale(1.5)',
                      }}
                    />
                  </div>
                  {/* Expanded content when hovered */}
                  <div
                    className={`mt-6 transition-all duration-500 overflow-hidden ${
                      hoveredBrand === brand.id
                        ? 'max-h-[200px] opacity-100'
                        : 'max-h-0 opacity-0'
                    }`}
                  >
                    {/* White line */}
                    <div
                      className="w-full h-[1px] bg-white mb-6 transition-all duration-500"
                      style={{
                        transform:
                          hoveredBrand === brand.id ? 'scaleX(1)' : 'scaleX(0)',
                        transformOrigin: 'left',
                      }}
                    />
                    {/* Services */}
                    <div className="space-y-4 text-left">
                      {brand.services.map((service, index) => (
                        <div
                          key={index}
                          className="flex items-center transition-all duration-500"
                          style={{
                            transform:
                              hoveredBrand === brand.id
                                ? 'translateX(0)'
                                : 'translateX(-20px)',
                            opacity: hoveredBrand === brand.id ? 1 : 0,
                            transitionDelay: `${index * 100}ms`,
                          }}
                        >
                          <img
                            src="/assets/arrow.svg"
                            alt="arrow"
                            className="w-6 h-6 mr-2"
                          />
                          <a
                            href={service.url}
                            className="text-white font-inter-bold text-lg cursor-pointer hover:underline transition-opacity"
                          >
                            {service.name}
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}
